import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { Clipboard } from '@angular/cdk/clipboard';
import {
  IconBillingComponent,
  IconCheckComponent,
  IconCopyComponent,
} from '@pedix-workspace/angular-ui-icons';

export type TransferDetailsData = {
  cvu?: string;
  alias?: string;
  accountHolder?: string;
};

@Component({
  selector: 'pxw-transfer-details-card',
  templateUrl: './transfer-details-card.component.html',
  styleUrls: ['./transfer-details-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoDirective,
    IconBillingComponent,
    IconCheckComponent,
    IconCopyComponent,
  ],
})
export class TransferDetailsCardComponent {
  private clipboard = inject(Clipboard);

  readonly data = input.required<TransferDetailsData>();

  readonly hasData = computed(() => {
    const d = this.data();
    return !!(d.cvu || d.alias || d.accountHolder);
  });

  copiedField = signal<'cvu' | 'alias' | null>(null);

  copyToClipboard(value: string, field: 'cvu' | 'alias') {
    this.clipboard.copy(value);
    this.copiedField.set(field);
    setTimeout(() => this.copiedField.set(null), 2000);
  }
}
